export enum ErrorPageType {
    ADD_ORDER_ITEM = 'add_order_item'
}